var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-users"},[(!_vm.activeUserId)?_c('rp-users-wellcome'):_c('rp-users-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }